export const MOVABLE_CONTROL_BTN = {
	movableFrameToggle: 'movableFrameToggle',
	photoBackgroundFrameToggle: 'photoBackgroundFrameToggle'
};

export const MOVABLE_BTN_SELECTOR = 'data-btn-type';
